import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link as RouterLink } from 'react-router-dom';
//import useAuth from '../hooks/useAuth';
import useProvideAuth from '../hooks/useAuth';
import AdsList from './AdsList';


export default function TopBar(){
  //const auth = useAuth();
  const auth = useProvideAuth();
  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6" sx={{flexGrow:1}}>Retail Ads</Typography>
        <Button color="inherit" component={RouterLink} to="/">Home</Button>
        <Button color="inherit" component={RouterLink} to="/pricing">Pricing</Button>
        <Button color="inherit" component={RouterLink} to="/dashboard">Dashboard</Button>
        {/* {auth.user && <Typography sx={{mr:2}}>{auth.user.email}</Typography>} */}
         <Button color="inherit" component={RouterLink} to="/login">Login</Button>
        <Button color="inherit" onClick={()=>{ auth.logout(); setTimeout(() => {}, 3000); window.location.href='/login'; console.log('Removed token', localStorage.getItem('access_token')); }}>Logout</Button>
        <Button color="inherit" component={RouterLink} to="/ads">Ads</Button>
        <Button color="inherit" component={RouterLink} to="/screens">Screens</Button>
        <Button color="inherit" component={RouterLink} to="/products">Products</Button>
        <Button color="inherit" component={RouterLink} to="/users">Users</Button>        
      </Toolbar>
    </AppBar>
  );
}
